import React from 'react';
import './SkeletonLoader.css';

export function MetricSkeleton() {
  return (
    <div className="skeleton-card" aria-hidden="true">
      <div className="skeleton-line skeleton-title" />
      <div className="skeleton-line skeleton-value" />
      <div className="skeleton-line skeleton-sub" />
    </div>
  );
}

export function ChartSkeleton({ height = 240 }) {
  return (
    <div className="skeleton-chart-container" style={{ height }} aria-hidden="true">
      <div className="skeleton-line skeleton-title" style={{ width: '40%' }} />
      <div className="skeleton-chart-area">
        <div className="skeleton-bar" style={{ height: '60%' }} />
        <div className="skeleton-bar" style={{ height: '85%' }} />
        <div className="skeleton-bar" style={{ height: '40%' }} />
        <div className="skeleton-bar" style={{ height: '95%' }} />
        <div className="skeleton-bar" style={{ height: '70%' }} />
        <div className="skeleton-bar" style={{ height: '50%' }} />
      </div>
    </div>
  );
}

export function TableSkeleton({ rows = 5 }) {
  return (
    <div className="skeleton-table" aria-hidden="true">
      <div className="skeleton-table-header">
        <div className="skeleton-line" style={{ width: '20%' }} />
        <div className="skeleton-line" style={{ width: '30%' }} />
        <div className="skeleton-line" style={{ width: '25%' }} />
        <div className="skeleton-line" style={{ width: '15%' }} />
      </div>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="skeleton-table-row">
          <div className="skeleton-line" style={{ width: '25%' }} />
          <div className="skeleton-line" style={{ width: '40%' }} />
          <div className="skeleton-line" style={{ width: '20%' }} />
          <div className="skeleton-line" style={{ width: '10%' }} />
        </div>
      ))}
    </div>
  );
}

export function ExecutiveHeroSkeleton() {
  return (
    <div className="skeleton-hero-container" aria-hidden="true">
      <div className="skeleton-hero-top-row">
        <div className="skeleton-line" style={{ width: '180px', height: '14px' }} />
        <div className="skeleton-line" style={{ width: '130px', height: '20px', borderRadius: '999px' }} />
      </div>
      <div className="skeleton-line" style={{ width: '75%', height: '32px', margin: '0.4rem 0' }} />
      <div className="skeleton-evidence-row">
        <div className="skeleton-line" style={{ width: '100px', height: '36px' }} />
        <div className="skeleton-line" style={{ width: '120px', height: '36px' }} />
        <div className="skeleton-line" style={{ width: '110px', height: '36px' }} />
      </div>
      <div className="skeleton-hero-actions">
        <div className="skeleton-line" style={{ width: '150px', height: '36px', borderRadius: '8px' }} />
        <div className="skeleton-line" style={{ width: '130px', height: '36px', borderRadius: '8px' }} />
      </div>
    </div>
  );
}

export function KpiQuadrantSkeleton() {
  return (
    <div className="actionable-kpi-quadrant skeleton-kpi-quadrant" aria-hidden="true">
      <MetricSkeleton />
      <MetricSkeleton />
      <MetricSkeleton />
      <MetricSkeleton />
    </div>
  );
}

export function BusinessCardsSkeleton({ count = 6 }) {
  return (
    <div className="skeleton-cards-grid" aria-hidden="true">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="skeleton-biz-card">
          <div className="skeleton-line" style={{ width: '65%', height: '18px' }} />
          <div className="skeleton-line" style={{ width: '40%', height: '12px' }} />
          <div className="skeleton-line" style={{ width: '90%', height: '12px' }} />
          <div className="skeleton-biz-meta-row">
            <div className="skeleton-line" style={{ width: '30%', height: '22px', borderRadius: '12px' }} />
            <div className="skeleton-line" style={{ width: '25%', height: '22px', borderRadius: '12px' }} />
          </div>
        </div>
      ))}
    </div>
  );
}
